import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { X, Copy } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ReferralProgram = ({ onClose }) => {
  const [referralCode, setReferralCode] = useState('LOADING');
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    fetchReferralData();
  }, []);

  const fetchReferralData = async () => {
    try {
      const response = await axios.get(`${API}/referral/my`);
      setReferralCode(response.data.referral_code);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const copyLink = () => {
    navigator.clipboard.writeText(`${window.location.origin}/auth?ref=${referralCode}`);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <motion.div
        initial={{ scale: 0.9 }}
        animate={{ scale: 1 }}
        onClick={(e) => e.stopPropagation()}
        className="bg-white rounded-3xl p-8 max-w-lg w-full mx-4"
      >
        <div className="flex justify-between items-start mb-6">
          <div>
            <h2 className="text-3xl font-black mb-2">Refer & Earn</h2>
            <p className="text-gray-600">Get 30 free minutes for each referral!</p>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="mb-6 p-6 bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl text-white text-center">
          <p className="text-sm opacity-80 mb-2">Your Referral Code</p>
          <p className="text-4xl font-black tracking-wider">{referralCode}</p>
        </div>

        <div className="mb-4">
          <input
            readOnly
            value={`${window.location.origin}/auth?ref=${referralCode}`}
            className="w-full px-4 py-3 border-2 rounded-xl mb-3 text-sm"
          />
          <button
            onClick={copyLink}
            className="w-full py-3 bg-black text-white rounded-full font-semibold hover:scale-105 transition"
          >
            {copied ? 'Copied!' : 'Copy Link'}
          </button>
        </div>

        <div className="p-4 bg-blue-50 rounded-xl">
          <p className="text-sm text-gray-700">
            <strong>How it works:</strong> Share your link with friends. When they sign up, you both get 30 free call minutes!
          </p>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default ReferralProgram;
